
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'avatar-stroke': {
    width: 13.3,
    height: 17.2,
    viewBox: '0 0 13.3 17.2',
    data: '<path pid="0" d="M12.548 17.25c-.4 0-.8-.3-.8-.8v-4.5c0-.8-.6-1.4-1.4-1.4h-7.5c-.8 0-1.4.6-1.4 1.4v4.5c0 .4-.3.8-.8.8s-.6-.4-.6-.8v-4.5c0-1.6 1.3-2.9 2.9-2.9h7.5c1.6 0 2.9 1.3 2.9 2.9v4.5c-.1.4-.4.8-.8.8zm-5.9-8.6c-2.4 0-4.3-1.9-4.3-4.3s1.9-4.3 4.3-4.3 4.3 1.9 4.3 4.3c0 2.3-1.9 4.3-4.3 4.3zm0-7.2c-1.6 0-2.8 1.3-2.8 2.9s1.3 2.8 2.8 2.8 2.8-1.3 2.8-2.8-1.3-2.9-2.8-2.9z"/>'
  }
})
